export default {
  ja:[
    "メールアドレス or ユーザーID",
    "パスワード",
    "新規登録",
    "ログイン",
  ],
  en: [
    "email or password",
    "password",
    "sign up",
    "sign in",
  ]
}
